import { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export function useProfilePhoto() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const [photoUrl, setPhotoUrl] = useState<string | null>(null);

	useEffect(() => {
		if (!isAuthenticated) return;

		let objectUrl: string | null = null;

		const fetchPhoto = async () => {
			const accounts = instance.getAllAccounts();
			if (!accounts[0]) return;

			let token: string;
			try {
				const result = await instance.acquireTokenSilent({
					scopes: ["User.Read"],
					account: accounts[0],
				});
				token = result.accessToken;
			} catch (err) {
				if (err instanceof InteractionRequiredAuthError) {
					await instance.acquireTokenRedirect({ scopes: ["User.Read"] });
				}
				return;
			}

			try {
				const res = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
					headers: { Authorization: `Bearer ${token}` },
				});
				if (!res.ok) return;
				const blob = await res.blob();
				objectUrl = URL.createObjectURL(blob);
				setPhotoUrl(objectUrl);
			} catch {
				// No photo set — fall back to initials avatar
			}
		};

		fetchPhoto();

		return () => {
			if (objectUrl) URL.revokeObjectURL(objectUrl);
		};
	}, [instance, isAuthenticated]);

	return photoUrl;
}
